<template>
  <div class="container" v-sound>
    <div class="content">
      <div class="menu-items-wrapper">
        
        <div class="tabs">
          <button
            v-for="tab in tabs"
            :key="tab"
            :class="['tab', { active: tab === activeTab }]"
            @click="selectTab(tab)"
          >
            <p v-html="tab.label"></p>
          </button>
        </div>
        <div :class="['menu-items', { 'list-layout': isDrinkOrAlcolTab }]">
          <div
            v-for="item in paginatedItems"
            :key="item.id"
            :class="['item', { 'out-of-stock': item.flag === 2 }]"
            @click="showDetail(item)"
          > 
            <div v-if="item.flag === 2" class="sold-out-overlay">
              <span>SOLD OUT</span>
            </div>
            <div class="item-image" v-if="!isDrinkOrAlcolTab">
              <img 
                v-if="item.image_url" 
                :src="item.image_url" 
                alt="商品写真" 
                class="image" 
              />
              <img 
                v-else 
                src='/img/menu/no_image.png'
                alt="デフォルト写真" 
                class="image" 
              />
            </div>
            <div :class="['item-info', { 'full-width': isDrinkOrAlcolTab }]">
              <template v-if="isDrinkOrAlcolTab">
                <div class="drink-label-container">
                  <span class="drink-bullet">・</span>
                  <div class="drink-name" :class="{ 'long-text': item.label.length > 8 }" v-html="item.label"></div>
                </div>
                <div class="drink-price">
                  <span v-if="item.price === 0">無料</span>
                  <span v-else>
                    {{ Math.round(item.price / 1.1).toLocaleString() }}円
                    <span class="tax-included-price">(税込{{ item.price.toLocaleString() }}円)</span>
                  </span>
                </div>
              </template>
              <div v-else>
                <p :class="{ 'long-text': item.label.length > 10 }" v-html="item.label"></p>
                <p v-if="item.price === 0">無料</p>
                <p v-else>
                  {{ Math.round(item.price / 1.1).toLocaleString() }}円
                  <span class="tax-included-price">(税込{{ item.price.toLocaleString() }}円)</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="pagination">
          <button @click="prevPage" :disabled="currentPage === 1"><i class="fa-solid fa-caret-left"></i>前へ</button>
          <span>{{ currentPage }} / {{ totalPages }}</span>
          <button @click="nextPage" :disabled="currentPage === totalPages">次へ<i class="fa-solid fa-caret-right"></i></button>
        </div>
      </div>

      <div class="cart">
        <div class="cart-header">
          <div class="cart-title">カート一覧</div>
          <div v-if="remainingTime !== ''" class="drink-plan-timer">
            <p>
              <span v-if="typeof remainingTime === 'number'">
                飲み放題<br>残り時間<br> <span class="time-value">{{ remainingTime }}</span> 分
              </span>
              <span v-else>
                {{ remainingTime }}
              </span>
            </p>
          </div>
        </div>
        <div class="cart-items">
          <div v-for="(cartItem, index) in cartItems" :key="index" class="cart-item">
            <span><p v-html="cartItem.label"></p></span>
            <div class="quantity-controls">
              <button @click="subtractQuantity(cartItem.id)"><i class="fa-solid fa-minus"></i></button>
              <span>{{ cartItem.quantity }}</span>
              <button @click="addQuantity(cartItem.id)"><i class="fa-solid fa-plus"></i></button>
            </div>
          </div>
        </div>
        <button 
          :class="['confirm-order', { 'can-order': cartItems.length > 0 }]"
          @click="showConfirm('order')" 
          :disabled="cartItems.length === 0"
        >注文確定</button>
        <div class="total">
          合計金額 {{ Math.round(totalPriceNumber / 1.1).toLocaleString() }}円 
          <span class="tax-included-price"><br>(税込{{ totalPrice }}円)</span>
        </div>
        <button class="checkout" @click="$router.push('/checkout-confirm')">お会計する</button>
        <button class="call-staff" @click="showConfirm('called')">スタッフ呼び出し</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      tabs: [],
      activeTab: '',
      items: [],
      tablesessions: [],
      currentPage: 1,
      uuid: localStorage.getItem('deviceUUID'),
      diningTableID: localStorage.getItem('diningTableID'),
      remainingTime: '',
      timerId: null,
    };
  },
  created() {
    // Check for mobile screen size
    if (window.innerWidth <= 768) {
      this.$router.replace('/menu-mobile');
      return;
    }

    this.axios({
      method: 'GET',
      url: '/v1/connection/test',
    })
      .then((response) => {
        console.log(response.data.status);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
    this.getMenus();
    this.getTableSessions();
  },
  mounted() {
    // this.startTimer(); // watchに移行
  },
  beforeUnmount() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  watch: {
    drinkPlanEndTime: {
      handler(newValue) {
        if (this.timerId) {
          clearInterval(this.timerId);
          this.timerId = null;
        }
        if (newValue) {
          this.startTimer();
        } else if (this.remainingTime === 0) {
          // 何もしない（0分を維持）
        } else {
          this.remainingTime = '';
        }
      },
      immediate: true,
    },
    $route: {
      handler(to) {
        // Menuページに戻ってきたときにタイマーの状態を同期する
        if (to.path === '/menu') {
          if (this.drinkPlanEndTime && !this.timerId) {
            this.startTimer();
          } else if (!this.drinkPlanEndTime && this.timerId) {
            clearInterval(this.timerId);
            this.timerId = null;
            // 既に0なら維持、それ以外は空にする
            if (this.remainingTime !== 0) this.remainingTime = '';
          }
        }
      },
      immediate: true, // Menuページが直接ロードされた場合にも実行されるように
    },
  },
  computed: {
    ...mapState(['user', 'helper']),
    ...mapState('cart', ['items', 'drinkPlanEndTime']),
    cartItems() {
      return this.$store.state.cart.items;
    },
    totalPages() {
      const total = Math.ceil(this.items.length / this.itemsPerPage);
      return total > 0 ? total : 1;
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.items.slice(start, end);
    },
    totalPriceNumber() {
      const historyItems = this.$store.state.orderhistory.items;
      return historyItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    },
    totalPrice() {
      return this.totalPriceNumber.toLocaleString();
    },
    isDrinkOrAlcolTab() {
      if (!this.activeTab || !this.activeTab.name) {
        return false;
      }
      const name = this.activeTab.name.toLowerCase();
      return name === 'alcohol' || name === 'drink' || name === 'other-alcohol';
    },
    itemsPerPage() {
      return this.isDrinkOrAlcolTab ? 16 : 8;
    },
  },
  methods: {
    startTimer() {
      if (this.drinkPlanEndTime) {
        this.updateRemainingTime(); // 即時実行
        this.timerId = setInterval(this.updateRemainingTime, 1000);
      }
    },
    updateRemainingTime() {
      const now = new Date().getTime();
      const diff = this.drinkPlanEndTime - now;

      if (diff <= 0) {
        if (this.timerId) {
          clearInterval(this.timerId);
          this.timerId = null;
        }
        // 終了扱いにしても表示は "0" のままにする
        this.remainingTime = 0;
        // ※store側で自動終了処理が必要なら別ロジックで行ってください（ここで dispatch すると表示が消える可能性がある）
        return;
      }

      const minutes = Math.ceil(diff / (1000 * 60));
      this.remainingTime = minutes;
    },
    getMenus() {
      this.axios({
        method: 'GET',
        url: '/v1/menu/get/list',
        params: {
          user_id: this.user.id,
          flags: [1, 2],
        },
      })
        .then((response) => {
          const res = response.data;
          this.tabs = res.list.data;
          if (this.tabs.length > 0) {
            this.activeTab = this.tabs[0];
            this.getMenuItems(this.activeTab.id);
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    getMenuItems(tabId = null) {
      const params = {
        user_id: this.user.id,
        flags: [1, 2, 998],
        groupVariants: true,
      };

      if (this.activeTab && this.activeTab.name === 'recommended') {
        params.isRecommended = true;
      } else {
        params.menuId = tabId;
      }

      this.axios({
        method: 'GET',
        url: '/v1/menuitem/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.items = res.list.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    getTableSessions() {
      return this.axios({
        method: 'GET',
        url: '/v1/tablesession/get/list',
        params: {
          activeTableId: this.diningTableID,
          user_id: this.user.id,
        },
      })
        .then((response) => {
          const res = response.data;
          this.tablesessions = res.list.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    selectTab(tab) {
      this.activeTab = tab;
      this.items = [];
      this.currentPage = 1;
      this.getMenuItems(tab.id);
    },
    getCartItemQuantity(itemId) {
      const targetCartItem = this.cartItems.filter((item) => item.id === itemId);
      return targetCartItem?.[0]?.quantity || 0;
    },
    removeCart(id) {
      this.$store.dispatch('cart/removeCart', id, { root: true });
    },
    addQuantity(id) {
      this.$store.dispatch('cart/addQuantity', id, { root: true });
    },
    subtractQuantity(id) {
      if (this.getCartItemQuantity(id) === 1) {
        this.removeCart(id);
      } else {
        this.$store.dispatch('cart/subtractQuantity', id, { root: true });
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      }
    },
    showDetail(item) {
      if (item.flag === 2) return;
      const data = {
        item,
      };
      const args = {
        modalName: 'itemDetail',
        data,
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
    showConfirm(type) {
      const data = {
        cartItems: this.cartItems,
        uuid: this.uuid,
        diningTableID: this.diningTableID,
        tableSessionID: this.tablesessions[0]?.id,
        type,
      };
      const args = {
        modalName: 'Confirm',
        data,
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
  },
};
</script>

<style scoped>
/* ... existing styles ... */
.item.out-of-stock {
  cursor: not-allowed;
}

.sold-out-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  border-radius: 6px; /* .item の角丸に合わせる */
}

.sold-out-overlay span {
  color: #E53935;
  font-weight: bold;
  font-size: 2rem; /* PC表示用に少し大きく */
  border: 3px solid #E53935;
  padding: 5px 15px;
  transform: rotate(-10deg);
  background-color: rgba(255,255,255,0.8);
}

.item {
  position: relative;
}
.drink-plan-timer {
  background-color: #A63E2F;
  color: white;
  text-align: center;
  padding: 5px 5px; /* パディングを調整 */
  font-size: 1.1rem; /* フォントサイズを調整 */
  font-weight: bold;
  border-radius: 5px; /* 角丸を追加 */
  line-height: 1.2;
  /* position関連は削除 */
}

.cart-header { /* 新しく追加 */
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px; /* カートアイテムとの間に余白 */
}

.content {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
  width: 70vw; /* Constrain content to the left 70% of the screen */
  padding-top: 0px; /* ここを0pxに変更 */
}
/* ... existing styles ... */
html, body {
  height: 100%;
  margin: 0;
  overflow: hidden;
}

.container {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  max-width: none;
  font-family: '游明朝体', 'Yu Mincho', 'ヒラギノ明朝 ProN', 'Hiragino Mincho ProN', serif;
}

.content {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
  width: 70vw; /* Constrain content to the left 70% of the screen */
}

.tabs {
  display: flex;
  justify-content: flex-start;
  gap: 1vw;
  width: 100%;
  height: 12vh;
  margin-bottom: 5vh;
  position: relative;
  overflow-x: auto;
  scrollbar-width: none;
  border-bottom: 5px solid rgba(160, 65, 52, 1);
  z-index: 0;
  overflow-y: hidden;
  touch-action: pan-x;
}

.tabs::-webkit-scrollbar {
  display: none;
}

.tab {
  text-align: center;
  padding: 0.5vh 0.5vw;
  background-color: #DDD4C1;
  color: rgb(80, 67, 51);
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  min-width: 15vw;
  max-width: 15vw;
  flex-grow: 0;
  border: none;
  outline: none;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border: 3px solid rgba(194, 182, 149, 1);
  border-bottom: none;
  z-index: 2;
  white-space: pre-wrap;
  line-height: 1;
}
.tab.active {
  background-color: rgba(160, 65, 52, 1);
  border: none;
  color: #ccc;
}

.menu-items-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%; /* Changed from 70% to 100% of its parent (.content) */
  height: 100%;
  padding: 2%; /* padding is added here */
}

.menu-items {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  grid-auto-rows: 16vh;
  flex-grow: 1;
  overflow-y: auto;
  height: calc(100% - 50px);
}
.menu-items.list-layout {
  grid-auto-rows: 7vh;
  gap: 16px;
}

.menu-items.list-layout .item {
  padding: 0;
}

.item-info.full-width {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  text-align: left;
}

.item-info.full-width p:last-child {
  text-align: right;
}

.item {
  background-color: #F4EDE4;
  padding: 6px;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 
    8px 8px 16px rgba(0, 0, 0, 0.1), 
    /* 影2: 左上 (反対方向) */
    -8px -8px 16px rgba(0, 0, 0, 0.1);
}

.item.dummy {
  background-color: transparent;
  pointer-events: none;
}

.item-image {
  width: 70%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F4EDE4;
  overflow: hidden;
}

.item-image img {
  width: 80%;
  height: 100%;
  object-fit: fill;
}

.item-info {
  position: relative;
  width: 60%;
  padding: 8px;
  color: black;
  border-radius: 4px;
  text-align: center;
  white-space: pre-wrap;
}

.item-info p:first-child {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
}

.item-info p:first-child.long-text {
  font-size: 1rem;
}

.item-info p:last-child {
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0;
  text-align: right;
  white-space: nowrap;
}

.drink-label-container {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.drink-bullet {
  color: rgba(152, 121, 89, 1);
  font-size: 1.2rem;
  font-weight: bold;
  margin-right: 5px;
}

.drink-name {
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.drink-name.long-text {
  font-size: 0.8rem;
}

.drink-price {
  font-size: 1.3rem;
  font-weight: bold;
  margin: 0;
  text-align: right;
  flex-shrink: 0;
  white-space: nowrap;
}

.tax-included-price {
  font-size: 0.8em;
}

.cart {
  position: fixed;
  top: 0;
  right: 0;
  width: 28vw;
  height: 100vh;
  padding: 3%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  background-image: url('/img/menu/cart-background.jpeg');
  background-size: 100% 100%;
  background-position: right center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.cart-title {
  font-weight: bold;
  color: #ccc;
  font-size: 1.6rem;
  margin-bottom: -4px;
}

.cart-items {
  height: 70vh;
  max-height: 70vh;
  overflow-y: auto;
  padding: 8px;
  margin: 5% 0;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #FBF5EB;
}

.cart-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1vh;
  background-color: transparent;
  border-bottom: 2px solid black;
}

.cart-item span:first-child {
  font-weight: bold;
  font-size: calc(100% + 0.1rem);
  white-space: pre-wrap;
  margin: 0;
}

.cart-item span:nth-child() {
  font-weight: bold;
  font-size: 1.2rem;
  margin: 0;
  left: -1vw;
}

.cross {
  padding-right: 2vw;
  font-size: 1.2rem;
  cursor: pointer;
}

.quantity-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 10vw;
  height: 5vh;
  border-radius: 5px;
  background-color: transparent;
  padding: 0;
  box-sizing: border-box;
}

.quantity-controls button {
  width: 3vw;
  height: 100%;
  font-size: 1.2rem;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #333;
  border-radius: 5px;
  padding: 0;
  box-sizing: border-box;
}

.quantity-controls span {
  text-align: center;
  height: 100%;
  font-size: 1.2rem;
  font-weight: bold;
  line-height: 5vh;
  background-color: #FBF5EB;
  width: 4vw;
  box-sizing: border-box;
}

.confirm-order {
  background-color: #D9776E;
  color: white;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  font-size: 1.5rem;
  display: inline-block;
  margin: 1vh 0 0;
}

.confirm-order:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.confirm-order.can-order {
  animation: bounce-and-blink 1.5s ease-in-out infinite;
}

@keyframes bounce-and-blink {
  0%, 100% {
    transform: scale(1);
    background-color: #E89B94;
  }
  50% {
    transform: scale(1.05);
    background-color: #D9776E;
  }
}

.checkout {
  background-color: rgba(160, 65, 52, 1);
  color: white;
  padding: 8px 16px;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  font-size: 2rem;
  margin-top: 0;
}

.call-staff {
  background-color: #F4EDE4;
  color: #A63E2F;
  padding: 8px 16px;
  border: 2px solid #A63E2F;
  border-radius: 8px;
  font-size: 1.3rem;
  cursor: pointer;
  text-align: center;
  width: auto;
  display: inline-block;
  margin-top: auto;
}

.total {
  font-size: 1.4rem;
  font-weight: bold;
  text-align: center;
  margin: 1vh 0 2px;
  color: #ccc;
}

.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 16px;
  position: relative;
}

.pagination button {
  padding: 8px 24px;
  background-color: #5d3a2e;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  font-size: 1.4rem;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination span {
  font-size: 1.4rem;
  font-weight: bold;
  color: #333;
  text-align: center;
}

.time-value {
  font-size: 1.8rem;
  font-weight: bold;
  margin: 0 3px;
}
</style>
